module.exports = __webpack_public_path__ + "static/img/bgagent1.f9d8881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgagent1.png
// module id = Ht8m
// module chunks = 4